<div class="border-container" [ngClass]='{"white-bordered": whiteBordered}'> <div class="border-line" [ngClass]="{accentuated: accentuated}"> </div> </div> 